import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import logo from '../Assets/logo.png';
import { name } from "../Constant";
import Footer from "../Components/footer";
import Button from "../Components/button";
import { RedirectIfLogin, getSession, UpdateState, getState, handleSubmit, BreedForm, AlertMessage, AlertMessageOut, serializeArray } from "../Components/function";

class Login extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      userID : '',
      password: '',
      loading: '',
      message: '',
    }
    }
    
    componentDidMount(){
      RedirectIfLogin();
    }

    componentDidUpdate(prevProps) {
      RedirectIfLogin();
    }
 
  render(){
    return (
        <div className="App">
      <div className="body-wrappers" id="body-wrapper">
        <div className="form-first-child"> </div>

        <div className="form-wrapper">
      <div className="form-wrap-login">
        <div className="logo-wrap">
          <div className="logo-inner-wrap">
          <NavLink to="/">
            <img className="logo" src={logo} title={name + " Logo"} alt={name + " Logo"}/>
            </NavLink>
          </div>
          </div>
      <div className="form-inner-wrap">
       <div className="h1s">Login to Portal </div>
       
       <BreedForm route="login">

       {AlertMessageOut(this)}

       <div className="form-group-lg">   
      <input type="text" className="form-input" id="userID" placeholder="User ID" 
       onChange={(input) => UpdateState(this, "userID", input.target.value) }/>
       </div>

       <div className="form-group-lg">   
      <input type="password" className="form-input" id="password" placeholder="Password"
       onChange={(input) => UpdateState(this, "password", input.target.value) }/>
       </div>
      

       <Button 
       wrapperClass="form-group-lg" 
       buttonClass="btn btn-blue btn-link" 
       buttonText="LOGIN ACCOUNT"
       buttonAction="login"
       self={this} />

         </BreedForm>

         <div className="form-group-lg">
         <NavLink to="/recover">
       Forgot Password? Click here
       </NavLink>
       </div> 
         </div>
        </div>
      </div>
      </div>

      <Footer/>
    </div>
    );
}

}

export default Login;